import { Component, OnInit, ViewChild } from '@angular/core';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { NavController } from '@ionic/angular';
import  { Manufacturer, ManufacturerService, Category, CategoryService } from 'octali-lib-shop';
import { GenericListComponent, SortPipe } from 'octali-lib-utils';
import { combineLatest } from 'rxjs';
import { CategorySpanItemComponent } from '../../category/category-span-item/category-span-item.component';
import { ManufacturerSpanItemComponent } from '../../manufacturer/manufacturer-span-item/manufacturer-span-item.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {

  @ViewChild('listCategoryComponent', { read: GenericListComponent, static: false }) listCategoryComponent!: GenericListComponent;
  @ViewChild('listManufacturerComponent', { read: GenericListComponent, static: false }) listManufacturerComponent!: GenericListComponent;
  
  public manufacturers:Array<Manufacturer>;
  public categories: Array<Category>;
  public categoriesId:Map<string,Category>;
  public categoriesItemList:any;
  public manufacturersItemList:any;
  public columnManufacturer: "name";
  public order: 1;

  constructor(
    private manufacturerService: ManufacturerService,
    private categoriesService:CategoryService,
    private navCtrl: NavController,
    private iab: InAppBrowser,
  ) { 

    combineLatest([
      this.manufacturerService.getManufacturersObs(),
      this.categoriesService.getCategoriesObs(),
      this.categoriesService.getCategoriesIdObs()
    ])
    .subscribe( ([manufacturers, categories, categoriesId])=> {
      if( manufacturers && categories && categoriesId ){
        let st = new SortPipe();
        this.manufacturers = manufacturers;
        this.manufacturersItemList = [];
        st.transform(this.manufacturers,{property:"name",order:1});  
        for( let manufacturer of manufacturers)
          if( manufacturer.statut == "publish" )
            this.manufacturersItemList.push({component:ManufacturerSpanItemComponent,datas:manufacturer});
        setTimeout(() => {
          this.listManufacturerComponent.setDatas( this.manufacturersItemList);  
        }, 50);
        this.categories = categories;
        this.categoriesId = categoriesId;
        st.transform(this.categories,{property:"name",order:1});
        this.categoriesItemList = [];
        for( let cat of this.categories ) {
          if( cat.level == 0 ){
            this.categoriesItemList.push({component:CategorySpanItemComponent,datas:cat, options:{espace:2*cat.level+"em"}});
            if( cat.children.length > 0 ){
              let cats = [];
              for( let child of cat.children )
                cats.push( this.categoriesId.get(child) );
              st.transform(cats,{property:"name",order:1});  
              for( let child of cats )  
                this.categoriesItemList.push({component:CategorySpanItemComponent,datas:child, options:{espace:child.level+"em"}});
            }
          }
        }
        setTimeout(() => {
          this.listCategoryComponent.setDatas( this.categoriesItemList);  
        }, 50);
        
      }
    });    
  }

  ngOnInit() {  
  }

  goTo(url){
    this.navCtrl.navigateRoot( url );
  }

  goToCat(cat){
    this.navCtrl.navigateRoot( "/product/category/"+cat.id);

  }

  facebook() {
    this.iab.create('https://www.facebook.com/degriff.laine');
  }

  instagram() {
    this.iab.create('https://www.instagram.com/degrifflaine');
  }

  twitter() {
    this.iab.create('https://twitter.com/degrifflaine');
  }

  pinterest() {
    this.iab.create('https://www.pinterest.fr/degrifflaine');
  }

  youtube() {
    this.iab.create('https://www.youtube.com/channel/UCIgS86GTMuqApVewK8uhhbw');
  }

  selectCategories( cat: string ) {
    let category = this.categoriesId.get(cat);
    this.navCtrl.navigateRoot( "/categories/"+category.name+"/"+category.id );
  }

  selectManufacturers( manufacturer  ) {
    let name = manufacturer.name.replace(/\/|\s/g, "-").toLowerCase();
    this.navCtrl.navigateRoot( "/fournisseurs/"+encodeURI(name.toLowerCase())+"/"+manufacturer.id );
  }
}
